/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { getRegistrarList } from 'store/actions/user.action';
import '../../../styles/dashboard/admin.scss';
import { CheckAccess, getMyRole, roles } from '../../../utils/handler';
import DomainCategory from './DomainCategory';
import ManualAppraisal from './manualAppraisal';
import { GeneratePromoCode } from './promoCode';
import ReconcilePanel from './ReconcileTab';
import { RegistrarPanel } from './RegistrarDashboard';
import SellDomainPanel from './SellDomainTab';

import { UserSettings } from './userSettings';
interface NavType {
  name: string;
  component?: any;
  isAdmin?: boolean;
}
export const ManagementDashboard: React.FC = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState('Users');
  const navItems: NavType[] = [
    { name: 'Users', isAdmin: true },
    { name: 'Manual Appraisals', component: ManualAppraisal },
    { name: 'Estibot Category', component: DomainCategory },
    { name: 'Promo Code', component: GeneratePromoCode },
    { name: 'Registrar Dashboard', component: RegistrarPanel, isAdmin: true },
    { name: 'Reconciliation', component: ReconcilePanel, isAdmin: true },
    { name: 'Sell Domains', component: SellDomainPanel, isAdmin: true },

    // { name: "IfThen Changes", component: IfThenChanges },
  ];

  useEffect(() => {
    if (getMyRole().includes(roles.consultant)) {
      setActiveTab('Manual Appraisals');
    }
    if (getMyRole().includes(roles.admin)) {
      getRegistrarList();
      setActiveTab('Users');
    }
  }, []);

  const getTab = () => {
    let currentTabObj = _.find(navItems, { name: activeTab }) || navItems[0];
    if (currentTabObj.component) return <currentTabObj.component />;
  };
  return (
    <div className="container mt-3">
      <div className="space-around">
        <ul className="nav nav-tabs fs-17">
          {navItems.map((nav: NavType, index: number) =>
            nav.isAdmin && !getMyRole().includes(roles.admin) ? null : nav.name === 'Estibot Category' && !CheckAccess('ChangeCategoryValues') ? null : (
              <li key={index} className="nav-item c-pointer" onClick={() => setActiveTab(nav.name)}>
                <span className={'nav-link  f-bold text-nowrap' + (activeTab === nav.name ? 'active' : '')}>{nav.name}</span>
              </li>
            ),
          )}
        </ul>
      </div>
      <div className="container bootstrap snippets boot dey p-0">
        {activeTab === 'Users' && getMyRole().includes(roles.admin) ? <UserSettings /> : null}
        {getTab()}
      </div>
    </div>
  );
};

export default ManagementDashboard;
